import React from 'react';

type Props = {
  className?: string;
}
export const FavoriteVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '1.6' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M9 4H15C16.0609 4 17.0783 4.42159 17.8284 5.17203C18.5786 5.92248 19 6.94029 19 8.00158V18.2056C18.9989 18.5068 18.9224 18.803 18.7773 19.067C18.6322 19.3309 18.4232 19.5543 18.1695 19.7165C17.9157 19.8788 17.6254 19.9747 17.325 19.9957C17.0246 20.0166 16.7237 19.9618 16.45 19.8362L12.83 18.1856C12.5694 18.0667 12.2864 18.0052 12 18.0052C11.7136 18.0052 11.4306 18.0667 11.17 18.1856L7.55 19.8362C7.27626 19.9618 6.97541 20.0166 6.67501 19.9957C6.37461 19.9747 6.08426 19.8788 5.83054 19.7165C5.57682 19.5543 5.36784 19.3309 5.22274 19.067C5.07764 18.803 5.00105 18.5068 5 18.2056V8.00158C5 6.94029 5.42143 5.92248 6.17157 5.17203C6.92172 4.42159 7.93913 4 9 4Z' />
    </svg>
  );
};
